import styled from 'styled-components';
import { Layout } from '@design-system';

export const PlaceholderWrapper = styled(Layout.FlexRow)`
  border-width: 1px;
  border-style: dashed;
  border-radius: 8px;
`;
